import React from 'react';
import { useFilterContext } from '../../context/aptmetrix/FilterContext';
import { useTooltip } from './useTooltip';
import FilterButton from './FilterButton';
import TooltipShell, { FilterActions } from './TooltipShell';

const GANGNAM_TIME_OPTIONS = [10, 20, 30, 40, 50, 60];

const GangnamTimeFilter = ({ isOpen, onToggle, onClose, selectedRegion, data, onFilterChange }) => {
    const {
        filterUIState,
        setFilterUIState,
        setGangnamTimeFilter,
    } = useFilterContext();

    const { maxGangnamTime, isGangnamTimeFilterActive } = filterUIState;

    const { tooltipRef, buttonRef } = useTooltip(isOpen, onClose);

    const updateUI = (updates) => setFilterUIState(prev => ({ ...prev, ...updates }));

    const handleToggle = () => {
        if (!selectedRegion) {
            alert('지역을 먼저 선택하세요');
            return;
        }
        onToggle();
    };

    const handleTimeChange = (minutes) => {
        updateUI({ maxGangnamTime: maxGangnamTime === minutes ? null : minutes });
    };

    const apply = () => {
        const isActive = maxGangnamTime !== null;
        updateUI({ isGangnamTimeFilterActive: isActive });
        setGangnamTimeFilter({ maxTime: maxGangnamTime });
        onFilterChange({ maxTime: maxGangnamTime });
        onClose();
    };

    const reset = () => {
        updateUI({ maxGangnamTime: null, isGangnamTimeFilterActive: false });
        onFilterChange(null);
        onClose();
    };

    const isDisabled = !data || data.length === 0;

    return (
        <div className="relative">
            <FilterButton
                ref={buttonRef}
                label="강남역소요시간"
                activeLabel={`강남${maxGangnamTime}분`}
                isActive={isGangnamTimeFilterActive}
                isDisabled={isDisabled}
                onClick={handleToggle}
            />
            {isOpen && (
                <TooltipShell ref={tooltipRef} title="강남역 소요시간 필터" onClose={onClose} className="right-0">
                    <div className="mb-3">
                        <h4 className="text-sm font-medium mb-2">강남역까지 소요시간</h4>
                        <div className="flex flex-wrap gap-2">
                            {GANGNAM_TIME_OPTIONS.map(minutes => (
                                <button
                                    key={minutes}
                                    onClick={() => handleTimeChange(minutes)}
                                    className={`px-3 py-1 text-xs rounded-full ${
                                        maxGangnamTime === minutes
                                            ? 'bg-blue-500 text-white'
                                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                    }`}
                                >
                                    {minutes}분 이내
                                </button>
                            ))}
                        </div>
                    </div>
                    <FilterActions onReset={reset} onApply={apply} />
                </TooltipShell>
            )}
        </div>
    );
};

export default GangnamTimeFilter;
